import React, { useEffect, useState, useContext } from "react"
import { Mutation } from "react-apollo"
import Modal, { ModalContent, ModalHeader } from "../Modal"
import AppContext from "../../shared/AppContext"
import Button from "../Button"
import TextField from "../TextField"
import NEWSLETTER_SUBSCRIBE from "../../graphql/newsletterSubscribe.graphql"
import { EMAIL_REGEX } from "../../shared/constants"
import "./style.scss"

const ActivateAccount = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [email, setEmail] = useState("")
  const [errors, setErrors] = useState("")
  const [successMessage, setSuccessMessage] = useState("")
  const { trackEvent } = useContext(AppContext)

  useEffect(() => {
    if (!isModalOpen) {
      setEmail("")
      setErrors("")
      setSuccessMessage("")
    }
  }, [isModalOpen])

  const isValidEmail = () => {
    let reg = EMAIL_REGEX
    let isValid = reg.test(email)
    if (isValid && email.length !== 0) {
      setErrors("")
      return true
    } else {
      setErrors("Invalid email")
      return false
    }
  }

  const signup = (mutate) => {
    if (isValidEmail()) {
      mutate({ variables: { email } }).then((res) => {
        let { subscribeNewsletter } = res.data
        if (subscribeNewsletter) {
          setSuccessMessage(subscribeNewsletter.message)
          trackEvent("Activated Newsletter Account", {
            email,
          })
        } else {
          setErrors("An unknown has error occurred. Please try again later.")
        }
      })
    }
  }

  return (
    <Mutation mutation={NEWSLETTER_SUBSCRIBE}>
      {(mutate) => {
        return (
          <div className="activate-account-container">
            <p>
              Looking to access our{" "}
              <a href="https://etr.ai/newsletter">Newsletter</a>?
            </p>
            <p>Activate your account today</p>
            <Button
              type="submit"
              classes={["primary"]}
              style={{
                margin: "auto",
                marginTop: "1em",
                paddingLeft: "2em",
                paddingRight: "2em",
              }}
              action={() => setIsModalOpen(true)}
              text="Activate Account"
              data-cy="login-form-activate"
            />
            <Modal
              isOpen={isModalOpen}
              close={() => setIsModalOpen(false)}
              classes={["medium"]}
            >
              <ModalContent>
                <ModalHeader text="Activate Account" />
                {!successMessage && (
                  <div className="activate-account-modal">
                    <TextField
                      value={email}
                      name="email"
                      fullWidth={true}
                      onChange={(e) => {
                        if (e) {
                          setEmail(e.target.value)
                          setErrors("")
                        }
                      }}
                      placeholder="Email Address"
                      errors
                      errorOptions={{
                        outline: true,
                        showMessage: true,
                        message: errors,
                        hasError: !!errors,
                      }}
                      dataCy="activate-account-email"
                    />
                    <div className="activate-account-buttons-container">
                      <Button
                        action={() => setIsModalOpen(false)}
                        classes={["activate-account-cancel-button"]}
                        text={"Cancel"}
                        data-cy="activate-account-cancel-button"
                      />
                      <Button
                        action={() => signup(mutate)}
                        classes={["activate-account-add-button"]}
                        text={"Activate"}
                        data-cy="activate-account-add-button"
                      />
                    </div>
                  </div>
                )}
                {!!successMessage && (
                  <div className="activate-account-modal">
                    <div className="success-message">{successMessage}</div>
                    <div className="success-message-button-container">
                      <Button
                        action={() => setIsModalOpen(false)}
                        classes={["activate-account-close-button"]}
                        text="Close"
                        data-cy="activate-account-close-button"
                      />
                    </div>
                  </div>
                )}
              </ModalContent>
            </Modal>
          </div>
        )
      }}
    </Mutation>
  )
}

export default ActivateAccount
